import React from 'react';
import styled, { css } from 'styled-components';
import {
  kleinBlue,
  midnight,
  white,
  spacer16,
  screenMdMin,
} from '@spotify-internal/encore-foundation';
import { Header } from './Header';
import { Hero } from './Hero';
import { Video } from './Video';
import { Features } from './Features';
import { ClaimBanner } from './ClaimBanner';
import { Testimonials } from './Testimonials';
import { Products } from './Products';
import { Faqs } from './Faq';
import { Footer } from './Footer';
import { GimletAcademy } from './GimletAcademy';
import { useMe } from '../../hooks/useMe';
import { isS4PodShowWrappedBannersEnabled } from '../../lib/Features';
import { WrappedHero } from './WrappedHero';

export function LandingPage() {
  const me = useMe();
  const isWrappedEnabled = me ? isS4PodShowWrappedBannersEnabled(me.features) : false;

  return (
    <LandingPageContainer data-testid="landing-page--container" isWrappedEnabled={isWrappedEnabled}>
      <Header />
      {isWrappedEnabled ? <WrappedHero /> : <Hero />}
      <Video />
      <Features />
      <ClaimBanner />
      <Testimonials />
      <Products />
      <GimletAcademy />
      <Faqs />
      <Footer />
    </LandingPageContainer>
  );
}

const LandingPageContainer = styled.div<{ isWrappedEnabled: boolean }>`
  color: ${white};
  ${props =>
    props.isWrappedEnabled
      ? css`
          background-color: ${kleinBlue};
      }`
      : css`
          background-color: ${midnight};
          background-image: url('/images/landing_page/bg-01-hero.svg');
        `}
  background-position: top ${spacer16} right -500px;
  background-repeat: no-repeat;
  background-size: 1975px 660px;
  overflow: hidden;
  @media (min-width: ${screenMdMin}) {
    background-position: top center;
  }
`;
